import React from 'react';
import { Helmet } from 'react-helmet';
import { FaStar, FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import ProductCard from '../components/ProductCard';
import { products } from '../context/CartContext';

function Home() {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <Helmet>
        <title>HeroPixelLab - Oppdag de mest interessante dataspillene på nettet</title>
        <meta name="description" content="HeroPixelLab | Utforsk vår eksklusive kolleksjon av premium online dataspill. Kvalitetsprodukter og unik spillopplevelse." />
        <link href="https://heropixellab.com/" rel="canonical"/>
      </Helmet>

      <section className="hero-section">
        <div className="container">
          <h1 className="hero-title">Velkommen til HeroPixelLab</h1>
          <p className="hero-subtitle">
            Oppdag de mest spennende online dataspillene med enestående kvalitet og innovative løsninger. Vår butikk tilbyr eksklusive spillopplevelser for ekte gamere.
          </p>
          <a href="#katalog" className="hero-button">Utforsk Spillene</a>
        </div>
      </section>

      <section className="advantages">
        <div className="container">
          <h2 className="advantages-title">Hvorfor Velge Oss</h2>
          <div className="advantages-grid">
            <div className="advantage-card">
              <FaStar className="advantage-icon" />
              <h3>Premium Kvalitet</h3>
              <p>Vi håndplukker hvert spill for å sikre høyest mulig kvalitet og spillopplevelse. Kun det beste når våre kunder.</p>
            </div>
            <div className="advantage-card">
              <FaHeart className="advantage-icon" />
              <h3>Personlig Service</h3>
              <p>Vårt dedikerte team er alltid klare til å hjelpe deg med spørsmål og veiledning. Din tilfredshet er vår prioritet.</p>
            </div>
            <div className="advantage-card">
              <FaShoppingCart className="advantage-icon" />
              <h3>Enkel Handel</h3>
              <p>Handle trygt og enkelt med vår sikre betalingsløsning. Vi sørger for en smidig prosess fra bestilling til levering.</p>
            </div>
            <div className="advantage-card">
              <FaHome className="advantage-icon" />
              <h3>Levering Hjem</h3>
              <p>Vi leverer digitale nøkler direkte til din e-post. Få tilgang til spillene dine umiddelbart etter kjøp.</p>
            </div>
          </div>

          <div className="stats">
            <div className="stat-item">
              <p className="stat-number">15000+</p>
              <p className="stat-label">Fornøyde Kunder</p>
            </div>
            <div className="stat-item">
              <p className="stat-number">10+</p>
              <p className="stat-label">Års Erfaring</p>
            </div>
            <div className="stat-item">
              <p className="stat-number">500+</p>
              <p className="stat-label">Spill i Katalogen</p>
            </div>
          </div>
        </div>
      </section>

      <section className="text-section">
        <div className="container">
          <h2>Dette er HeroPixelLab</h2>
          <p className="about-text">
            HeroPixelLab er din ledende nettbutikk spesialisert på online dataspill. Grunnlagt i 2015 har vi vokst til en av de mest anerkjente aktørene i spillmarkedet. Vårt mål er å gi gamere tilgang til de beste spillene med enestående service og konkurransedyktige priser. Vi samarbeider med etablerte utviklere og distributører for å sikre autentiske produkter og lovlige lisenser for alle våre spill.
          </p>
          <p className="about-text">
            Vår kolleksjon har et bredt utvalg av sjanger, fra intense skytespill og rollespill til spennende racingeventyr og strategiske titler. Hvert spill i vår butikk gjennomgår en streng kvalitetskontroll for å sikre at det oppfyller våre høye standarder. Vi brenner for lidenskapen og gleden som spill bringer til livet, og vi ønsker å dele denne gleden med spillere over hele verden.
          </p>
          <p className="about-text">
            Vi er stolte av å tilby garantier og sertifikater på kvalitet for alle våre produkter. Hvert spill kommer med en garanti som sikrer autentisitet og funksjonalitet. Våre kunder kan være trygge på at de får ekte og fungerende spill. Vi har også et erfaringsspeil omkommunikasjon og service som alltid er tilgjengelig for å svare på spørsmål og løse eventuelle problemer.
          </p>
          <p className="about-text">
            Hvorfor velge HeroPixelLab? Fordi vi ikke bare selger spill, vi er spillentusiaster som forstår dine behov. Vi investerer i teknologiske løsninger som gjør handleopplevelsen rask, enkel og sikker. Vårt kundesenter er alltid klart med hjelp og støtte. Vi tror på bygge tillit og langvarige forhold med våre kunder. Velg oss for en enestående spillopplevelse hver eneste gang.
          </p>
          <p className="about-text">
            I hjertet av vår virksomhet ligger en historie av dedikasjon og kvalitet. Vi startet som en liten gruppe spillentusiaster med en stor drøm og har vokst steg for steg gjennom hardt arbeid og engasjement. Vår filosofi er enkel: gir glede til hver spiller gjennom fantastiske spill og eksepsjonell service, og det er det vi leverer daglig.
          </p>
        </div>
      </section>

   

      <section id="katalog" className="catalog">
        <div className="container">
          <h2 className="catalog-title">Vår Katalog av Spill</h2>
          <div className="catalog-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>

      <div className="page-number">Side 1</div>
    </div>
  );
}

export default Home;